<mat-tab-group dynamicHeight>
   
      <mat-tab label="CONTENIDO 1">
          <app-contenido-inicio></app-contenido-inicio>
      </mat-tab >
      <mat-tab label="CONTENIDO 2">
      <app-contenido-inicio></app-contenido-inicio>
      </mat-tab >
      <mat-tab label="CONTENIDO 3">
      <app-contenido-inicio></app-contenido-inicio>
      </mat-tab >
    </mat-tab-group>
    